/* ==========================================================================
   GM · Red de seguridad de colores corporativos
   Azul #143F4D · Amarillo #E8A733

   Recorre la página y sustituye los azules y dorados antiguos que quedan
   guardados en plantillas, bloques de HTML personalizado y CSS personalizado
   de secciones nativas del tema.

   Reglas:
   - Azules antiguos (texto, fondo o borde)  -> azul #143F4D
   - Dorados antiguos como fondo             -> amarillo #E8A733 (y si el texto era blanco, pasa a azul)
   - Dorados antiguos como texto             -> amarillo si va sobre fondo oscuro, azul si va sobre fondo claro
   - Dorados antiguos como borde             -> amarillo

   No se aplica en la ficha «Selección Pepa Muñiz» (product.castillo-de-las-torres).
   Tampoco toca los formularios de Klaviyo ni los elementos con estado (pestañas, botones activables).
   Para excluir cualquier otro bloque, añade el atributo data-gm-marca-skip a su contenedor.
   ========================================================================== */
(function () {
  'use strict';

  if (!document.body || document.body.classList.contains('template-product-castillo-de-las-torres')) return;

  var AZUL = 'rgb(20, 63, 77)';
  var AMARILLO = 'rgb(232, 167, 51)';

  var NAVY = [
    '38,49,58',   /* #26313a */
    '39,53,62',   /* #27353e */
    '44,59,71',   /* #2c3b47 */
    '61,74,84',   /* #3d4a54 */
    '60,72,84',   /* #3c4854 */
    '63,69,83',   /* #3f4553 */
    '46,52,64',   /* #2e3440 */
    '34,47,55',   /* #222f37 */
    '59,71,79',   /* #3b474f */
    '47,57,65',   /* #2f3941 */
    '17,70,87'    /* #114657 */
  ];

  var GOLD = [
    '178,126,14',  /* #b27e0e */
    '178,126,43',  /* #b27e2b */
    '223,193,12',  /* #dfc10c */
    '217,161,92',  /* #d9a15c */
    '199,154,75',  /* #c79a4b */
    '190,152,60',  /* #be983c */
    '241,182,52',  /* #f1b634 */
    '168,138,41',  /* #a88a29 */
    '165,126,39',  /* #a57e27 */
    '223,189,112', /* #dfbd70 */
    '167,121,25'   /* #a77919 */
  ];

  function parse(c) {
    var m = c && c.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    if (!m) return null;
    var a = m[4] === undefined ? 1 : parseFloat(m[4]);
    if (a === 0) return null;
    return { k: m[1] + ',' + m[2] + ',' + m[3], r: +m[1], g: +m[2], b: +m[3], a: a };
  }

  function withAlpha(base, a) {
    if (a >= 1) return base;
    return base.replace('rgb(', 'rgba(').replace(')', ', ' + a + ')');
  }

  function luminance(c) {
    function ch(v) { v = v / 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }
    return 0.2126 * ch(c.r) + 0.7152 * ch(c.g) + 0.0722 * ch(c.b);
  }

  function effectiveBg(el) {
    while (el && el.nodeType === 1) {
      var c = parse(getComputedStyle(el).backgroundColor);
      if (c && c.a > 0.5) return c;
      el = el.parentElement;
    }
    return { r: 255, g: 255, b: 255 };
  }

  function isWhite(c) { return c && c.r > 240 && c.g > 240 && c.b > 240; }
  function isYellow(c) { return c && c.k === '232,167,51'; }

  /* No se tocan:
     - Formularios de Klaviyo (incrustados y ventanas emergentes): sus colores se deciden en Klaviyo.
     - Elementos con estado (pestañas, botones activables): el color se fija una sola vez al cargar y,
       con !important en línea, ya no cambiaría al activarlos (texto azul sobre fondo azul). Sus
       parejas de colores se fuerzan en pango-custom.css. */
  var SKIP = '[data-gm-marca-skip], [class*="klaviyo-form"], .needsclick, [class*="kl-private"]';
  var ESTADO = '[role="tab"], [aria-selected], [aria-pressed]';

  function fixEl(el) {
    if (el.closest(SKIP) || el.closest(ESTADO)) return;
    var cs = getComputedStyle(el);

    /* Fondo */
    var bg = parse(cs.backgroundColor);
    if (bg) {
      if (NAVY.indexOf(bg.k) !== -1) {
        el.style.setProperty('background-color', withAlpha(AZUL, bg.a), 'important');
      } else if (GOLD.indexOf(bg.k) !== -1) {
        el.style.setProperty('background-color', withAlpha(AMARILLO, bg.a), 'important');
        if (isWhite(parse(cs.color))) el.style.setProperty('color', AZUL, 'important');
      }
    }

    /* Texto */
    var tc = parse(getComputedStyle(el).color);
    if (tc) {
      if (NAVY.indexOf(tc.k) !== -1) {
        el.style.setProperty('color', AZUL, 'important');
      } else if (GOLD.indexOf(tc.k) !== -1) {
        el.style.setProperty('color', luminance(effectiveBg(el)) < 0.3 ? AMARILLO : AZUL, 'important');
      } else if (isWhite(tc) && isYellow(effectiveBg(el))) {
        el.style.setProperty('color', AZUL, 'important');
      }
    }

    /* Borde */
    if (cs.borderTopStyle !== 'none' && parseFloat(cs.borderTopWidth) > 0) {
      var bc = parse(cs.borderTopColor);
      if (bc) {
        if (NAVY.indexOf(bc.k) !== -1) el.style.setProperty('border-color', withAlpha(AZUL, bc.a), 'important');
        else if (GOLD.indexOf(bc.k) !== -1) el.style.setProperty('border-color', withAlpha(AMARILLO, bc.a), 'important');
      }
    }
  }

  function run(root) {
    root = root || document.body;
    if (root.nodeType !== 1) return;
    fixEl(root);
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var t = all[i].tagName;
      if (t === 'SCRIPT' || t === 'STYLE' || t === 'LINK' || t === 'META' || t === 'NOSCRIPT') continue;
      fixEl(all[i]);
    }
  }

  run();
  window.addEventListener('load', function () { run(); });
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });

  /* Contenido que se añade después (carrito lateral, filtros AJAX, vista rápida, apps) */
  var pending = [];
  var timer = null;
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) pending.push(added[j]);
      }
    }
    if (!pending.length || timer) return;
    timer = setTimeout(function () {
      var nodes = pending; pending = []; timer = null;
      for (var k = 0; k < nodes.length; k++) { if (nodes[k].isConnected) run(nodes[k]); }
    }, 200);
  }).observe(document.body, { childList: true, subtree: true });
})();
